import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
    transform :rotate(0deg);
  }
  to {
    transform :rotate(360deg);
  }
`

export default styled.div`
  max-width: ${props => props.theme.spinner.radius};
  margin-left: auto;
  margin-right: auto;
  width:${props => props.theme.spinner.radius};
  height:${props => props.theme.spinner.radius};
  border: 8px solid ${props => props.theme.spinner.color};
  border-top: 8px solid ${props => props.theme.spinner.background_color};
  border-radius: 50%;
  animation-name: ${rotate};
  animation-duration: 0.75s;
  animation-timing-function: linear;
  animation-play-state: running;
  animation-iteration-count: infinite;
`